import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import Header from '../Component/Header'
import Footer from '../Component/footer'
import { GetAction } from '../Component/GetAction'
import PaymentReceipt from './PaymentReceipt'

function formatAmount(value) {
  if (value == null || value === '') return '—'
  const amount = Number(value)
  if (Number.isNaN(amount)) return String(value)
  return `₹ ${amount.toLocaleString('en-IN')}`
}

function DonationHistory() {
  const history = useHistory()
  const [rows, setRows] = useState([])
  const [loader, setLoader] = useState(true)
  const [modal, setModal] = useState(false)
  const [pdfData, setPDFData] = useState()
  const [autoDownload, setAutoDownload] = useState(false)
  const loggedIn = Boolean(sessionStorage.getItem('id'))

  useEffect(() => {
    if (!loggedIn) {
      history.replace('/Login')
      return undefined
    }
    let mounted = true
    GetAction('get', { user_id: sessionStorage.getItem('id') }, 'donation/DonationHistory')
      .then((res) => {
        if (!mounted) return
        setRows(Array.isArray(res?.response) ? res.response : [])
        setLoader(false)
      })
      .catch(() => {
        if (mounted) setLoader(false)
      })
    return () => {
      mounted = false
    }
  }, [history, loggedIn])

  const openReceipt = (row, download = false) => {
    setPDFData(row)
    setAutoDownload(!!download)
    setModal(true)
  }

  const closeReceipt = () => {
    setModal(false)
    setAutoDownload(false)
  }

  if (!loggedIn) return null

  return (
    <>
      <Header />
      <div className="site-design bg-cream text-[#3d2918]">
        <main className="mx-auto min-h-[60vh] max-w-7xl px-4 py-8 sm:py-10">
          <div className="mb-6 flex items-center justify-center gap-2 sm:gap-3">
            <span className="text-gold" aria-hidden="true">✦</span>
            <span className="h-px w-8 bg-gradient-to-r from-transparent to-gold sm:w-16" />
            <h1 className="text-center text-3xl text-maroon sm:text-4xl">दान इतिहास</h1>
            <span className="h-px w-8 bg-gradient-to-l from-transparent to-gold sm:w-16" />
            <span className="text-gold" aria-hidden="true">✦</span>
          </div>
          <p className="mx-auto mb-6 max-w-2xl text-center text-sm leading-7 text-[#5c4938]">
            आपके द्वारा किए गए दान की सूची। रसीद देख सकते हैं या PDF डाउनलोड कर सकते हैं।
          </p>

          <div className="overflow-hidden rounded-2xl border border-[#f0e2c4] bg-white shadow-card">
            {loader ? (
              <p className="px-4 py-10 text-center text-sm text-[#5c4938]">दान सूची लोड हो रही है…</p>
            ) : rows.length === 0 ? (
              <div className="px-4 py-10 text-center">
                <p className="text-sm text-[#5c4938]">अभी कोई दान दर्ज नहीं है।</p>
                <Link to="/Donation" className="mt-4 inline-flex rounded-full bg-maroon px-4 py-2 text-sm font-semibold text-white">
                  ऑनलाइन दान करें →
                </Link>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="idx-history-table">
                  <thead>
                    <tr>
                      <th>क्र.</th>
                      <th>दान प्रकार</th>
                      <th>भुगतान का माध्यम</th>
                      <th>राशि</th>
                      <th>दिनांक</th>
                      <th>रसीद</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={row.payment_detail_id || row.payment_id || index}>
                        <td>{row.index || index + 1}</td>
                        <td>{row.type_name || '—'}</td>
                        <td>{row.mode_of_payment || '—'}</td>
                        <td>{formatAmount(row.payment_amount)}</td>
                        <td>{row.created_at || '—'}</td>
                        <td>
                          <div className="flex flex-wrap gap-2">
                            <button
                              type="button"
                              className="rounded-full border border-maroon px-3 py-1 text-xs font-semibold text-maroon"
                              onClick={() => openReceipt(row, false)}
                            >
                              देखें
                            </button>
                            <button
                              type="button"
                              className="rounded-full bg-maroon px-3 py-1 text-xs font-semibold text-white"
                              onClick={() => openReceipt(row, true)}
                            >
                              PDF
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {rows.length ? (
            <p className="mt-5 text-center">
              <Link to="/Donation" className="text-sm font-semibold text-maroon">
                ऑनलाइन दान करें →
              </Link>
            </p>
          ) : null}
        </main>
      </div>
      {modal ? (
        <PaymentReceipt
          hide={closeReceipt}
          title="Donation History"
          data={pdfData}
          autoDownload={autoDownload}
        />
      ) : null}
      <Footer />
    </>
  )
}

export default DonationHistory
